/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e6bb42d868f8f5ff390cb93c90dcd8191a2fcc63";
